import { render, staticRenderFns } from "./market-view.vue?vue&type=template&id=e812c1a8&scoped=true&"
import script from "./market-view.vue?vue&type=script&lang=ts&"
export * from "./market-view.vue?vue&type=script&lang=ts&"
import style0 from "./market-view.vue?vue&type=style&index=0&id=e812c1a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e812c1a8",
  null
  
)

export default component.exports